import { render, staticRenderFns } from "./HistoryList.vue?vue&type=template&id=0cf1ae9d"
import script from "./HistoryList.vue?vue&type=script&lang=js"
export * from "./HistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf1ae9d')) {
      api.createRecord('0cf1ae9d', component.options)
    } else {
      api.reload('0cf1ae9d', component.options)
    }
    module.hot.accept("./HistoryList.vue?vue&type=template&id=0cf1ae9d", function () {
      api.rerender('0cf1ae9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/task/HistoryList.vue"
export default component.exports